import {
    undef,
    showFormSummary
} from './';

const CHECK_AVAILABILITY_SUBMIT_ACTION_TYPE = 'check-availability';
const SEARCH_SUBMIT_ACTION_TYPE = 'search';

const DEFAULT_SUBMIT_ACTION_TYPE = SEARCH_SUBMIT_ACTION_TYPE;

const SUBMIT_ACTION_TYPES = [
    CHECK_AVAILABILITY_SUBMIT_ACTION_TYPE,
    SEARCH_SUBMIT_ACTION_TYPE
];

function hasSubmitActionType(ACTION_TYPE, submitOptions) {
    let {
        actionType
    } = submitOptions;

    actionType = `${actionType}`.toLowerCase();

    return actionType === ACTION_TYPE;
}

/* istanbul ignore next */
function hasDefaultSubmitActionType(submitOptions) {
    return hasSubmitActionType(DEFAULT_SUBMIT_ACTION_TYPE, submitOptions);
}

function hasCheckAvailabilitySubmitActionType(submitOptions) {
    return hasSubmitActionType(CHECK_AVAILABILITY_SUBMIT_ACTION_TYPE, submitOptions);
}

/* istanbul ignore next */
function hasSearchSubmitActionType(submitOptions) {
    return hasSubmitActionType(SEARCH_SUBMIT_ACTION_TYPE, submitOptions);
}

function showSubmitIcon(formOptions, submitOptions) {
    const {
        showIcons
    } = formOptions;

    const {
        showIcon
    } = submitOptions;

    return (
        showIcon ||
        showIcons && showIcon === undef
    );
}

function showSubmitPrimaryAction(submitOptions) {
    const {
        isPrimaryAction
    } = submitOptions;

    return isPrimaryAction;
}

function showSubmitDetailsPrimaryAction(mediaSettings, formOptions, submitOptions) {
    return (
        showSubmitPrimaryAction(submitOptions) ||
        showFormSummary(mediaSettings, formOptions)
    );
}

export {
    DEFAULT_SUBMIT_ACTION_TYPE,
    CHECK_AVAILABILITY_SUBMIT_ACTION_TYPE,
    SEARCH_SUBMIT_ACTION_TYPE,
    SUBMIT_ACTION_TYPES,
    hasDefaultSubmitActionType,
    hasCheckAvailabilitySubmitActionType,
    hasSearchSubmitActionType,
    showSubmitIcon,
    showSubmitPrimaryAction,
    showSubmitDetailsPrimaryAction
};
